import React from 'react';
import styled from '@emotion/styled';

import TextBlock from '../../components/shared/TextBlock';
import respond from '../../styles/mediaQueries';

const Text = styled('div')`
    flex: 0 1 44.8rem;

	& h5 {
		margin-top: 3.2rem;
	}

	& ul {
		list-style-type: none;
	}


`;

const Heading = styled('h1')`
	grid-row: 1 / 2;
	grid-column: 1 / 3;

	${respond('bp4')} {
		grid-row: 1 / 2;
		grid-column: 1 / 1;
	}
`;

const SupportText = styled('div')`
	& a {
		margin-right: 2.4rem;
	}

	${respond('bp4')} {
		margin-bottom: 4rem;
	}
`;

const TechList = styled('div')`
	display: grid;
	grid-template-columns: 1fr 1fr;
`;

const PageHeaderText = ({ title, children, techUsed, sourceLinks }) => {
	const techUsedList = techUsed.map(tech => {
		return <div key={tech}>{tech}</div>;
	});

	return (
		<React.Fragment>
			<Heading>{title}</Heading>
			<TextBlock>
				<Text>
					{children}

					<SupportText>
						<div>
							<h5>Tech Used</h5>
							<TechList>{techUsedList}</TechList>
						</div>
						<div>
							<h5>Source Code</h5>
							{sourceLinks.altMessage && (
								<p>{sourceLinks.altMessage}</p>
							)}
							{sourceLinks.api.link && (
								<a href={sourceLinks.api.link}>
									{sourceLinks.api.text}
								</a>
							)}
							{sourceLinks.frontend.link && (
								<a href={sourceLinks.frontend.link}>
									{sourceLinks.frontend.text}
								</a>
							)}
						</div>
					</SupportText>
				</Text>
			</TextBlock>
		</React.Fragment>
	);
};

export default PageHeaderText;
